import type { EventBusKey } from '@vueuse/core'

export const alprelaxEventKey: EventBusKey<string> = Symbol('symbol-key')